/** @format */

import "core-js/stable";
import "regenerator-runtime/runtime";

// fetch
import "unfetch/polyfill";
import "abortcontroller-polyfill/dist/polyfill-patch-fetch";

// KeyboardEvent.key
import kb_k from "keyboardevent-key-polyfill";
kb_k.polyfill();

// classList.js
// Polyfills incomplete classList implementation on IE11
import "classlist-polyfill";

/* Copyright (c) 2016 Tobias Buschor https://goo.gl/gl0mbf | MIT License https://goo.gl/HgajeK */
// https://gist.github.com/nuxodin/73a2c2423cbbf6818c28ad803985d5c7
if (!HTMLFormElement.prototype.reportValidity) {
    HTMLFormElement.prototype.reportValidity = function () {
        if (this.checkValidity()) return true;
        let btn = document.createElement("button");
        this.appendChild(btn);
        btn.click();
        this.removeChild(btn);
        return false;
    };
}
